import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import LoyaltyGuestLandingPage from './loyaltyGuestPage/LoyaltyGuestLandingPage'
import LoyaltyUserLandingPage from './loyaltyUserPage/LoyaltyUserLandingPage'
import LoyaltyAccountLandingPage from './loyaltyUserAccountPage/LoyaltyAccountLandingPage'

function LoyaltyLandingPageContainer() {
  const loggedIn = useAppSelector(selectLoggedIn)
  const loyaltyAccount = useAppSelector(state => state.loyalty.account.data)

  if (loggedIn) {
    if (loyaltyAccount) {
      return <LoyaltyAccountLandingPage />
    }
    return <LoyaltyUserLandingPage />
  }
  return <LoyaltyGuestLandingPage />
}

export default LoyaltyLandingPageContainer
